import {Divider, Carousel, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const TresM = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Competitor Analysis</Paragraph>
        <Text className='BaseText2'>Since there are no diagnostic products based on aptamers openly available on the market, we carried out an analysis of diagnostic products with similar fundamentals and objectives or with components integrated in our proposal.</Text>
        <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '80vh', background: 'transparent'}}>
          <Carousel autoplay effect='fade' dotPosition='bottom' style={{marginLeft: '50%', transform: 'translateX(-50%)', width: '90vh'}}>
            <div>
              <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-50.png'/>
              <p style={{textAlign: 'center'}}><b>Table 3.</b> Indirect competitors that might threat iMoAge. Our indirect competitors are mainly focused on aging tools that are used to detect the biological age of each person or for research purposes. All of them evaluate different hallmarks of aging.[10-12]</p>
            </div>
            <div>
              <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-51.png'/>
              <p style={{textAlign: 'center'}}><b>Table 4.</b> Direct competitors that might threat iMoAge. Our direct competitors are mainly focused on the biomarkers used to detect inflammaging. None of our competitors employed aptamers for the detection system. [13] [14]</p>
            </div>
          </Carousel>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default TresM;
